import React, { useState, useEffect } from 'react';
import Aux from '../../hoc/Aux';
import { axiosPublic } from '../../axios-wizard';
import { URLS } from '../../urls';
import LogoDescriptionTable from '../Shared/LogoDescriptionTable'

const LogoDescription = (props) => {

  const actionUrl = '/api/frontend_seal_list'
  const [logos, setLogos] = useState([]);

  const filterSeals = (logos) => logos.filter( x => x.display_frontpage === true)

  const sealsList = (logos) => {
    return filterSeals(logos).sort( (a,b) => parseInt(a.position) - parseInt(b.position)).map( (s, index) => <img key={s.id} style={{height: "70px", paddingRight: "20px"}} alt='' src={URLS['BACKEND'] + '/' + s.image_url} /> );
  }

  useEffect(() => {
      const fetchData = async () => {
        const result = await axiosPublic(
          actionUrl,
        );
        setLogos(result.data.frontend_seal_elements);
      };
      fetchData();
    }, []);

  return (
    <LogoDescriptionTable logos={logos} />
  )
};

export default LogoDescription;



// WEBPACK FOOTER //
// ./src/components/Home/LogoDescription.js